import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestSites from './components/LatestSites';
import StatsSection from './components/StatsSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '磁力网站大全',
    alternateName: '磁力网站导航',
    url: 'https://www.ciliwangzhan.com',
    description: '磁力网站精选推荐，汇聚全网最新磁力链接资源，支持磁力搜索、磁力下载一键直达。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.ciliwangzhan.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '磁力网站大全',
    url: 'https://www.ciliwangzhan.com',
    description: '磁力网站精选推荐平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@ciliwangzhan.com',
      contactType: 'customer service',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <HotRecommend />
          <StatsSection />
          <LatestSites />
          <FaqSection />
          <CtaSection />
        </main>
        <Footer />
      </div>
    </>
  );
}